document.addEventListener('DOMContentLoaded', function() {
  // Configuration - Define the missing variables
  const TRIGGER_PRODUCTS = ['bumbum-diapers-organic-bamboo']; // Add your product handles that should trigger the modal
  const MODAL_PRODUCT_HANDLE = 'swim-diaper-sample'; // Your sample product handle
  const TRIGGER_SIZE_INDEX = 4; // Index of size variant that triggers modal (0-based)
  
  // Configuration from Liquid template (fallback to defaults)
  const config = window.sizeModalConfig || {
    triggerSizeIndex: TRIGGER_SIZE_INDEX,
    sampleProductHandle: MODAL_PRODUCT_HANDLE,
    shouldTrigger: true
  };
  
  const translations = window.sizeModalTranslations || {};
  
  // Variable to track currently selected variant
  let currentlySelectedVariantId = null;
  let triggeringVariantId = null; // Track which variant triggered the modal
  let isOnProductPage = true; // Track if we're still on the product page
  let sampleAlreadyAdded = false; // Track if sample was already added to prevent multiple adds
  let modalShownForVariants = new Set(); // Track which variants have shown the modal
  
  // Check if current product should trigger modal
  function shouldTriggerModal() {
    const currentProductHandle = window.location.pathname.split('/').pop();
    console.log('Current product handle:', currentProductHandle); // Debug log
    return TRIGGER_PRODUCTS.some(handle => currentProductHandle.includes(handle));
  }
  
  // Fetch product data from Shopify
  async function fetchProductData(productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error('Product not found');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching product data:', error);
      return null;
    }
  }
  
  // Get all possible product variants from the page
  function getProductVariants() {
    // Try to get from window.product first
    if (window.product && window.product.variants) {
      return window.product.variants;
    }
    
    // Try to get from meta object
    if (window.meta && window.meta.product && window.meta.product.variants) {
      return window.meta.product.variants;
    }
    
    // Try to extract from variant buttons/options on the page
    const variantElements = document.querySelectorAll('[data-variant-id]');
    const variants = [];
    
    variantElements.forEach((element, index) => {
      const variantId = element.dataset.variantId;
      const variantTitle = element.textContent.trim() || element.value || `Variant ${index + 1}`;
      
      if (variantId) {
        variants.push({
          id: parseInt(variantId),
          title: variantTitle
        });
      }
    });
    
    return variants.length > 0 ? variants : null;
  }
  
  // Get currently selected variant ID from main product
  function getCurrentlySelectedVariantId() {
    // First, try to use our tracked value
    if (currentlySelectedVariantId) {
      console.log('Using tracked variant ID:', currentlySelectedVariantId);
      return currentlySelectedVariantId;
    }
    
    // Method 1: Check for selected variant in form (standard Shopify)
    const variantInput = document.querySelector('input[name="id"]:checked, select[name="id"] option:checked, input[name="id"][type="hidden"]');
    if (variantInput && variantInput.value) {
      console.log('Found variant via form input:', variantInput.value);
      return parseInt(variantInput.value);
    }
    
    // Method 2: Check for active variant button with specific selectors
    const possibleSelectors = [
      '[data-variant-id].active',
      '[data-variant-id].selected',
      '.variant-option.active',
      '.variant-option.selected',
      '.size-option.active',
      '.size-option.selected',
      '.product-variant.active',
      '.product-variant.selected'
    ];
    
    for (const selector of possibleSelectors) {
      const activeVariantButton = document.querySelector(selector);
      if (activeVariantButton && activeVariantButton.dataset.variantId) {
        console.log('Found variant via button selector:', activeVariantButton.dataset.variantId);
        return parseInt(activeVariantButton.dataset.variantId);
      }
    }
    
    // Method 3: Check for Shopify Analytics object
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
      console.log('Found variant via Shopify Analytics:', window.ShopifyAnalytics.meta.selectedVariantId);
      return parseInt(window.ShopifyAnalytics.meta.selectedVariantId);
    }
    
    // Method 4: Check for theme-specific variant tracking
    if (window.selectedVariantId) {
      console.log('Found variant via window.selectedVariantId:', window.selectedVariantId);
      return parseInt(window.selectedVariantId);
    }
    
    // Method 5: Look for variant ID in URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam) {
      console.log('Found variant via URL parameter:', variantParam);
      return parseInt(variantParam);
    }
    
    console.log('Could not find selected variant ID');
    return null;
  }
  
  // Format price according to Shopify's money format
  function formatPrice(cents) {
    const price = cents / 100;
    return `KWD ${price.toFixed(3)}`;
  }
  
  // Show one-time message
  function showMessage(message, type = 'success') {
    // Remove any existing messages first
    const existingMessage = document.querySelector('.modal-message');
    if (existingMessage) {
      existingMessage.remove();
    }
    
    const messageDiv = document.createElement('div');
    messageDiv.className = 'modal-message';
    messageDiv.textContent = message;
    
    const backgroundColor = type === 'success' ? '#4CAF50' : '#f44336';
    
    messageDiv.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${backgroundColor};
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      z-index: 10001;
      animation: slideIn 0.3s ease-out;
      font-size: 14px;
      max-width: 300px;
    `;
    
    document.body.appendChild(messageDiv);
    
    setTimeout(() => {
      messageDiv.remove();
    }, 3000);
  }

  // Function to update cart drawer immediately
 // Enhanced function to update cart drawer and open it
// Enhanced function to update cart drawer and cart count
async function updateCartDrawer() {
  try {
    console.log('Starting cart drawer update...');
    
    // Get current cart data
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    
    console.log('Updated cart data:', cartData);
    
    // ENHANCED METHOD: Update cart count with more comprehensive selectors
    const cartCountSelectors = [
      // Standard Shopify selectors
      '[data-cart-count]',
      '.cart-count',
      '.cart-counter',
      '.header-cart-count',
      '#cart-count',
      '.cart-count-bubble',
      '.cart-item-count',
      
      // Common theme-specific selectors
      '.cart-link__bubble',
      '.site-header__cart-count',
      '.header__icon--cart .icon__fallback-text',
      '.cart-button-count',
      '.cart-icon-count',
      '.mini-cart-count',
      '.cart-quantity',
      '.cart-badge',
      '.header-cart__count',
      '.cart-count-indicator',
      
      // Aria labels and screen reader text
      '[aria-label*="cart"]',
      '.visually-hidden:contains("items")',
      
      // ID-based selectors
      '#CartCount',
      '#cart-item-count',
      '#HeaderCartCount'
    ];
    
    // Update all possible cart count elements
    cartCountSelectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          // Update text content
          if (element.textContent !== undefined) {
            element.textContent = cartData.item_count;
          }
          
          // Update data attributes
          element.setAttribute('data-cart-count', cartData.item_count);
          
          // Update aria-label if it exists
          if (element.hasAttribute('aria-label')) {
            const currentLabel = element.getAttribute('aria-label');
            const updatedLabel = currentLabel.replace(/\d+/, cartData.item_count);
            element.setAttribute('aria-label', updatedLabel);
          }
          
          // Handle special cases for different themes
          if (element.tagName === 'SPAN' && element.parentElement.classList.contains('cart-link')) {
            element.innerHTML = cartData.item_count;
          }
          
          console.log(`Updated cart count element: ${selector}`);
        });
      } catch (error) {
        // Silently continue if selector fails
      }
    });
    
    // FORCE UPDATE: Trigger a page section refresh for cart elements
    try {
      // Method 1: Shopify section refresh (most reliable for cart updates)
      const cartSectionId = 'cart-icon-bubble'; // Common Shopify section ID
      const sectionUrl = `${window.location.origin}/?section_id=${cartSectionId}`;
      
      const sectionResponse = await fetch(sectionUrl);
      if (sectionResponse.ok) {
        const sectionHtml = await sectionResponse.text();
        
        // Try to find and replace the cart section
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sectionHtml;
        
        const newCartSection = tempDiv.querySelector(`#shopify-section-${cartSectionId}`);
        const currentCartSection = document.querySelector(`#shopify-section-${cartSectionId}`);
        
        if (newCartSection && currentCartSection) {
          currentCartSection.innerHTML = newCartSection.innerHTML;
          console.log('Cart section refreshed successfully');
        }
      }
    } catch (sectionError) {
      console.log('Section refresh method failed:', sectionError);
    }
    
    // THEME-SPECIFIC UPDATES: Try common theme functions
    const themeUpdateMethods = [
      () => window.theme && window.theme.cart && window.theme.cart.updateCount(cartData.item_count),
      () => window.theme && window.theme.updateCartCount && window.theme.updateCartCount(cartData.item_count),
      () => window.Shopify && window.Shopify.theme && window.Shopify.theme.cart && window.Shopify.theme.cart.updateCount(cartData.item_count),
      () => typeof updateCartCount === 'function' && updateCartCount(cartData.item_count),
      () => typeof refreshCart === 'function' && refreshCart(),
      () => typeof window.refreshCart === 'function' && window.refreshCart(),
      () => typeof window.updateCartDrawer === 'function' && window.updateCartDrawer(cartData),
      () => typeof window.cartDrawerRefresh === 'function' && window.cartDrawerRefresh()
    ];
    
    themeUpdateMethods.forEach((method, index) => {
      try {
        method();
        console.log(`Theme update method ${index + 1} executed successfully`);
      } catch (error) {
        // Silently continue if method fails
      }
    });
    
    // DISPATCH MULTIPLE EVENTS: Cover all possible event listeners
    const cartEvents = [
      new CustomEvent('cart:updated', { detail: { cart: cartData } }),
      new CustomEvent('cart:refresh', { detail: { cart: cartData } }),
      new CustomEvent('cart:change', { detail: { cart: cartData } }),
      new CustomEvent('cartUpdated', { detail: { cart: cartData } }),
      new CustomEvent('cartChanged', { detail: { cart: cartData } }),
      new CustomEvent('shopify:cart:update', { detail: { cart: cartData } }),
      
      // jQuery events if jQuery is available
      ...(window.jQuery ? [
        new CustomEvent('cart.updated', { detail: { cart: cartData } }),
        new CustomEvent('afterCartUpdate', { detail: { cart: cartData } })
      ] : [])
    ];
    
    cartEvents.forEach(event => {
      document.dispatchEvent(event);
      // Also dispatch on window for themes that listen there
      window.dispatchEvent(event);
    });
    
    // MANUAL DOM UPDATE: Force update visible cart elements
    try {
      // Update cart drawer content if it exists and is visible
      const cartDrawerSelectors = [
        '[data-cart-drawer]',
        '.cart-drawer',
        '.drawer--cart',
        '#cart-drawer',
        '.cart-sidebar',
        '.mini-cart',
        '#CartDrawer'
      ];
      
      for (const selector of cartDrawerSelectors) {
        const cartDrawer = document.querySelector(selector);
        if (cartDrawer && (cartDrawer.style.display !== 'none' || cartDrawer.classList.contains('is-open'))) {
          try {
            // Fetch the cart drawer section specifically
            const drawerResponse = await fetch(`${window.location.origin}/?section_id=cart-drawer`);
            if (drawerResponse.ok) {
              const drawerHtml = await drawerResponse.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(drawerHtml, 'text/html');
              const updatedDrawer = doc.querySelector(selector);
              
              if (updatedDrawer) {
                cartDrawer.innerHTML = updatedDrawer.innerHTML;
                console.log('Cart drawer content updated');
                break;
              }
            }
          } catch (drawerError) {
            console.log('Cart drawer update failed:', drawerError);
          }
        }
      }
    } catch (error) {
      console.log('Manual DOM update failed:', error);
    }
    
    // FINAL FALLBACK: Use MutationObserver to ensure count updates
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          
          // Check if this is a cart count element that needs updating
          cartCountSelectors.forEach(selector => {
            if (target.matches && target.matches(selector)) {
              if (target.textContent != cartData.item_count) {
                target.textContent = cartData.item_count;
                console.log('Force updated cart count via observer');
              }
            }
          });
        }
      });
    });
    
    // Observe the header and cart areas for changes
    const observeTargets = document.querySelectorAll('header, .header, .site-header, [data-cart-drawer]');
    observeTargets.forEach(target => {
      observer.observe(target, { 
        childList: true, 
        subtree: true, 
        characterData: true 
      });
    });
    
    // Stop observing after 2 seconds
    setTimeout(() => observer.disconnect(), 2000);
    
    console.log('Cart drawer update completed with enhanced methods');
    
    
  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}
  
  // Function to close modal
  function closeModal() {
    const modal = document.getElementById('size-variant-modal');
    if (modal) {
      modal.style.display = 'none';
    }
  }
  
  // Create modal HTML with theme default button
  function createModal(productData) {
    const modalHTML = `
      <div id="size-variant-modal" class="size-modal-overlay" style="display: none;">
        <div class="size-modal-content">
          <div class="size-modal-header">
            <h3>${translations.modalTitle || 'GET FREE SWIM DIAPPER SAMPLE'}</h3>
            <button class="size-modal-close" aria-label="Close modal">&times;</button>
          </div>
          <div class="size-modal-body">
            <div class="size-modal-product">
              <div class="size-modal-image">
                <img src="${productData.featured_image}" alt="${productData.title}" id="modal-product-image">
              </div>
              <div class="size-modal-info">
                <h4 id="modal-product-title">${productData.title}</h4>
                <div class="size-modal-price">
                  <span id="modal-product-price">${formatPrice(productData.price)}</span>
                </div>
                
                <!-- Size variants section -->
                <div class="size-modal-variants">
                  <div class="variant-options">
                    ${productData.variants.map(variant => `
                      <button class="variant-option ${variant.available ? '' : 'disabled'}" 
                              data-variant-id="${variant.id}"
                              ${!variant.available ? 'disabled' : ''}>
                        ${variant.title}
                      </button>
                    `).join('')}
                  </div>
                </div>
                
                <div class="size-modal-actions">
<p id="variant-warning" class="variant-warning-message tw-text-red-400 tw-text-sm tw-mt-2 block md:hidden">
  Please select a size before adding to cart.
</p>

                  <!-- Theme Default Add to Cart Button -->
                  <button
                    id="modal-add-to-cart-btn"
                    type="button"
                    class="button product-form__submit button bmd:tw-px-[0px] bmd:tw-min-h-[32px] bmd:tw-min-w-[116px] tw-text-quaternary tw-font-[700] tw-bg-[#EFF6E3] tw-border-[1px] tw-border-solid tw-border-[#4B6C64] tw-w-[100%] md:tw-p-0 button--primary"
                    disabled
                  >
                    <span class="tw-text-quaternary tw-font-[700] md:tw-text-[16px] tw-font-bold md:tw-px-[40px] md:tw-leading-[24px] md:tw-tracking-[0px] bmd:tw-text-[16px] button-add-to-cart">
                      ${translations.addSampleButton || 'Add Sample to Cart'}
                    </span>
  

                    <div class="loading-overlay__spinner hidden tw-absolute">
                      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    </div>
                  </button>
                  
                  <button class="btn-continue" id="continue-btn">
                    ${translations.continueButton || 'Continue with Current Selection'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
 

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // Add event listeners after modal is created
    setupModalEventListeners(productData);
  }
  
  // Setup event listeners for the modal
  function setupModalEventListeners(productData) {
    const modal = document.getElementById('size-variant-modal');
    const closeBtn = modal.querySelector('.size-modal-close');
    const continueBtn = modal.querySelector('#continue-btn');
    const addSampleBtn = modal.querySelector('#modal-add-to-cart-btn');
    const variantButtons = modal.querySelectorAll('.variant-option');
    
    let selectedVariantId = null;
        document.querySelectorAll('.variant-option').forEach(button => {
  button.addEventListener('click', () => {
    // Hide warning once a variant is selected
    const warning = document.getElementById('variant-warning');
      if (warning && warning.classList.contains('block')) {
      warning.classList.remove('block');
      warning.classList.add('hidden');
    }
  });
});
    // Close modal events - FIXED: Remove variant from set when modal is closed without adding to cart
    const handleModalClose = () => {
      // Remove the triggering variant from the set so modal can show again for the same variant
      if (triggeringVariantId) {
        modalShownForVariants.delete(triggeringVariantId);
        console.log('Removed variant from shown set:', triggeringVariantId);
      }
      hideModal();
    };
    
    closeBtn.addEventListener('click', handleModalClose);
    continueBtn.addEventListener('click', handleModalClose);
    
    // Click outside modal to close
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        handleModalClose();
      }
    });
    
    // Variant selection
    variantButtons.forEach(button => {
      button.addEventListener('click', function() {
        if (this.disabled) return;
        
        // Remove active class from all buttons
        variantButtons.forEach(btn => btn.classList.remove('active'));
        
        // Add active class to clicked button
        this.classList.add('active');
        
        // Store selected variant ID
        selectedVariantId = this.dataset.variantId;
        
        // Enable add to cart button
        addSampleBtn.disabled = false;
        
        // Update price if variant has different price
        const selectedVariant = productData.variants.find(v => v.id == selectedVariantId);
        if (selectedVariant) {
          const priceElement = modal.querySelector('#modal-product-price');
          priceElement.textContent = formatPrice(selectedVariant.price);
        }
      });
    });
    
     addSampleBtn.addEventListener('click', function(){
       const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
       const activeElement = document.activeElement;
        if (!selectedVariantId) {
          showMessage('Please select a size first', 'error');
          return;
        }
        const buttonText = this.querySelector('.button-add-to-cart');
        const spinner = this.querySelector('.loading-overlay__spinner');
        const mainProductVariantId = triggeringVariantId || getCurrentlySelectedVariantId();
        if (!mainProductVariantId) {
          showMessage('Please select a size for the main product first', 'error');
          return;
        }
        // Add both products in a single request
        const cartItems = [
          {
            id: selectedVariantId, // Sample product variant
            quantity: 1,
            properties: {
              _isSample: true,
              _isSampleProd: true,
              _uniqueKey: mainProductVariantId
            }
          },
          {
            id: mainProductVariantId, // Main product variant that triggered modal
            quantity: 1,
            properties: {
              _isSample: true,
              _isSampleMain: true,
              _uniqueKey: mainProductVariantId
            }
          }
        ];

        const payload = {
    items: cartItems
  };

  if (cartDrawer) {
    payload.sections = cartDrawer.getSectionsToRender().map(section => section.id);
    payload.sections_url = window.location.pathname;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(payload)
  })
    .then((response) => {
      if (!response.ok) throw new Error('Failed to add bundle to cart');
      return response.json();
    })
    .then((cartResponse) => {
      if (!cartDrawer) {
        window.location.href = '/cart';
        return;
      }

      cartDrawer.setActiveElement(activeElement);

      cartDrawer.renderContents(cartResponse);

      if (typeof cartDrawer.open === 'function') {
        hideModal();
        cartDrawer.open();
      }
      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
    })
    .catch((error) => {
      console.error('Cart error:', error);
    });

      
     })
  }
  
  // Show modal
  async function showModal() {
    // Check if modal already exists
    let modal = document.getElementById('size-variant-modal');
    
    if (!modal) {
      // Fetch product data
      const productData = await fetchProductData(config.sampleProductHandle);
      
      if (!productData) {
        console.error('Could not fetch sample product data');
        return;
      }
      
      // Create modal with fetched data
      createModal(productData);
      modal = document.getElementById('size-variant-modal');
    }
    
    // Show modal
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    // Focus management for accessibility
    const firstFocusableElement = modal.querySelector('button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (firstFocusableElement) {
      firstFocusableElement.focus();
    }
  }
  
  // Hide modal
  function hideModal() {
    const modal = document.getElementById('size-variant-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }
  
  // Clean up event listeners when navigating away or after cart actions
  function cleanupEventListeners() {
    isOnProductPage = false;
    console.log('Cleaned up modal event listeners');
  }
  
  // Function to handle variant selection and potentially show modal
  function handleVariantSelection(selectedVariantId) {
    // Don't handle if conditions not met
    if (!isOnProductPage || sampleAlreadyAdded) {
      console.log('Skipping variant selection - conditions not met');
      return;
    }
    
    // Convert to number for consistent comparison
    const variantId = parseInt(selectedVariantId);
    
    // Check if modal was already shown for this specific variant
    if (modalShownForVariants.has(variantId)) {
      console.log('Skipping variant selection - modal already shown for variant:', variantId);
      return;
    }
    
    // Update our tracked variant
    currentlySelectedVariantId = variantId;
    
    // Get product variants
    const productVariants = getProductVariants();
    
    if (productVariants && productVariants.length > 0) {
      // Find the index of the selected variant
      const selectedVariantIndex = productVariants.findIndex(variant => 
        variant.id === variantId
      );
      
      console.log('Selected variant index:', selectedVariantIndex);
      console.log('Trigger size index:', config.triggerSizeIndex);
      
      // Only trigger modal if the selected variant index is >= trigger index
      if (selectedVariantIndex !== -1 && selectedVariantIndex >= config.triggerSizeIndex) {
        console.log('✓ Triggering modal for size index:', selectedVariantIndex);
        
        // Store the variant that triggered the modal
        triggeringVariantId = variantId;
        
        // Mark modal as shown for this specific variant
        modalShownForVariants.add(variantId);
        
        setTimeout(() => {
          showModal();
        }, 200);
      } else {
        console.log('✗ Not triggering modal. Index:', selectedVariantIndex, 'Required:', config.triggerSizeIndex);
      }
    } else {
      console.warn('Could not get product variants for index calculation');
    }
  }
  
  // Main initialization
  function init() {
    if (!shouldTriggerModal() || !config.shouldTrigger) {
      console.log('Modal initialization skipped - not a trigger product or disabled');
      return;
    }
    
    console.log('Initializing size modal with config:', config);
    
    // Listen for all possible variant selection methods
    
    // Method 1: Form changes
    document.addEventListener('change', function(event) {
      if (!isOnProductPage || sampleAlreadyAdded) return;
      
      if (event.target.name === 'id') {
        console.log('Variant changed via form:', event.target.value);
        handleVariantSelection(event.target.value);
      }
    });
    
    // Method 2: Button clicks
    document.addEventListener('click', function(event) {
      if (!isOnProductPage || sampleAlreadyAdded) return;
      
      const target = event.target;
      
      // Skip clicks inside cart drawer or modal
      if (target.closest('.cart-drawer') || 
          target.closest('#size-variant-modal') ||
          target.closest('[data-cart-drawer]') ||
          target.closest('.drawer') ||
          target.closest('.cart-popup')) {
        return;
      }
      
      // Check if clicked element is a variant selector
      const variantElement = target.closest('[data-variant-id]') || target;
      
      if (variantElement && variantElement.dataset.variantId) {
        console.log('Variant changed via button click:', variantElement.dataset.variantId);
        setTimeout(() => {
          handleVariantSelection(variantElement.dataset.variantId);
        }, 100);
      }
    });
    
    // Method 3: Custom events
    document.addEventListener('variant:change', function(event) {
      if (!isOnProductPage || sampleAlreadyAdded) return;
      
      if (event.detail && event.detail.variant) {
        console.log('Variant changed via custom event:', event.detail.variant.id);
        handleVariantSelection(event.detail.variant.id);
      }
    });
    
    // Method 4: MutationObserver for dynamic changes
    const observer = new MutationObserver(function(mutations) {
      if (!isOnProductPage || sampleAlreadyAdded) return;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && 
            (mutation.attributeName === 'class' || mutation.attributeName === 'data-selected')) {
          const target = mutation.target;
          if ((target.classList.contains('active') || target.classList.contains('selected')) &&
              target.dataset.variantId) {
            console.log('Variant changed via DOM mutation:', target.dataset.variantId);
            handleVariantSelection(target.dataset.variantId);
          }
        }
      });
    });
    
    // Observe variant-related elements
    const observeElements = document.querySelectorAll('[data-variant-id], .variant-option, .size-option');
    observeElements.forEach(element => {
      observer.observe(element, { attributes: true, attributeFilter: ['class', 'data-selected'] });
    });
    
    // Cleanup listeners
    window.addEventListener('beforeunload', cleanupEventListeners);
    window.addEventListener('popstate', cleanupEventListeners);
    document.addEventListener('cart:open', cleanupEventListeners);
    document.addEventListener('drawer:open', cleanupEventListeners);
  }
  
  // Start the initialization
  init();
});

// Add CSS styles
const modalStyles = `
<style>
.size-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.size-modal-content {
  background: white;
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.size-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.size-modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.size-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.size-modal-close:hover {
  color: #333;
}

.size-modal-body {
  padding: 20px;
}

.size-modal-product {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.size-modal-image {
  flex: 0 0 300px;
}

.size-modal-image img {
  width: 100%;
  height: auto;
  border-radius: 4px;
}

.size-modal-info {
  flex: 1;
}

.size-modal-info h4 {
  margin: 0 0 10px 0;
  font-size: 1.8rem;
  color: #333;
  font-weight:700;
  letter-spacing:0;
}

.size-modal-price {
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.size-modal-variants {
  margin-bottom: 20px;
}

.variant-options {
  display: flex;
  gap: 10px;
}

.variant-option {
  border: 1.072px solid #000;
  background: white;
  border-radius: 12px;
  cursor: pointer;
  color: rgb(77 110 102 / var(--tw-text-opacity, 1));
  font-weight: 700;
  line-height: 16.8px;
  padding: 3px;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  /* Optimize rendering */
  will-change: border, box-shadow;
  transform: translateZ(0); /* Force hardware acceleration */
}


.variant-option.active {
  border: 2px solid #4B6C64;
  box-shadow: 0 0 0 2px #4b6c6433;
  padding:2px;
}

.variant-option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  text-decoration: line-through;
    pointer-events: none;

}

.size-modal-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.size-modal-content #modal-add-to-cart-btn {
  position: relative !important;
  width: 100% !important;
  margin-bottom: 0 !important;
}

/* Ensure loading spinner is positioned correctly */
.size-modal-content .loading-overlay__spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.size-modal-content .loading-overlay__spinner.hidden {
  display: none !important;
}

/* Continue Button */
.btn-continue {
  padding: 12px 24px;
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  color: #6c757d;
  transition: all 0.2s ease;
  text-align: center;
  font-size: 14px;
}

.btn-continue:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  color: #495057;
}
.variant-warning-message{
color:red;
font-size:12px;
}
/* Success/Error Messages */
.modal-message {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .size-modal-product {
    flex-direction: column;
  }
  
  .size-modal-image {
    flex: none;
  }
  
  .size-modal-actions {
    flex-direction: column;
  }
  
  .btn-add-sample,
  .btn-continue {
    min-width: auto;
  }
}
</style>
`;

// Inject styles
document.head.insertAdjacentHTML('beforeend', modalStyles);